import React, { useState, useEffect } from "react";
import corpBanner from "../assets/images/Corporate & TPA.jpg";
// import useSeo from "../hooks/useSeo";
// import SeoHelmet from "../components/SeoHelmet";
import { Helmet } from "react-helmet-async";
import {
  fetchCorporateTpaPageSeo,
  fetchListOfTpaCorporates,
  fetchListOfTpaInsurance,
} from "../Adapter/PageAdapter";
import { baseImage_path } from "../variables/Variables";
import { stripHtmlForMeta } from "../utils/seoMetaText";

const AcTpas = () => {
  const [showAllCorporates, setShowAllCorporates] = useState(false);
  const [showAllTpas, setShowAllTpas] = useState(false);
  const [corporate, setCorporates] = useState([]);
  const [tpainsurance, setTpainsurance] = useState([]);
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    const loadSeo = async () => {
      try {
        console.log("Calling fetchCorporateTpaPageSeo...");
        const res = await fetchCorporateTpaPageSeo();
        console.log("API Response:", res);
        if (res && res.data) {
          setSeoData(res.data);
        }
      } catch (e) {
        console.error("Direct SEO fetch failed:", e);
      }
    };

    loadSeo();
  }, []);

  // const seoData = useSeo(fetchCorporateTpaPageSeo);

  useEffect(() => {
    const fetchData = async () => {
      const corporateData = await fetchListOfTpaCorporates();
      const corporateInsurance = await fetchListOfTpaInsurance();

      // if (corporateData) setCorporates(corporateData);
      // if (corporateInsurance) setTpainsurance(corporateInsurance);
      if (corporateData) {
        const allLiItems = corporateData.flatMap(
          (item) => item.corporate_name.match(/<li[^>]*>.*?<\/li>/g) || []
        );
        setCorporates(allLiItems);
      }

      if (corporateInsurance) {
        const allLiItems = corporateInsurance.flatMap(
          (item) => item.name.match(/<li[^>]*>.*?<\/li>/g) || []
        );
        setTpainsurance(allLiItems);
      }
    };

    fetchData();
  }, []);

  return (
    <>

      {/* {seoData && <SeoHelmet seoData={seoData} />} */}
      {seoData && (
        <Helmet>
          <title>{seoData.seo_title}</title>
          <meta name="title" content={seoData.meta_title} />
          <meta name="description" content={stripHtmlForMeta(seoData.meta_description)} />
          <meta name="keywords" content={seoData.meta_keywords} />

          <meta property="og:title" content={seoData.og_title} />
          <meta property="og:description" content={stripHtmlForMeta(seoData.og_description)} />
          <meta property="og:type" content={seoData.og_type} />
          <meta property="og:url" content={seoData.og_url} />
          <meta property="og:image" content={`${baseImage_path}/${seoData.og_image}`} />
          <meta property="og:locale" content={seoData.og_locale} />
          <meta property="og:site_name" content={seoData.og_site_name} />
          <meta property="article:modified_time" content={seoData.article_modified_time} />

          <meta name="twitter:card" content={seoData.twitter_card} />
          <meta name="twitter:title" content={seoData.twitter_title} />
          <meta name="twitter:description" content={stripHtmlForMeta(seoData.twitter_description)} />
          <meta name="twitter:image" content={`${baseImage_path}/${seoData.twitter_image}`} />
          <meta name="twitter:site" content={seoData.twitter_site} />

          <link rel="canonical" href={seoData.canonical_link} />

          {/* Custom scripts injection */}
          {seoData.custom_scripts && (
            <script type="text/javascript" dangerouslySetInnerHTML={{ __html: seoData.custom_scripts }} />
          )}
        </Helmet>
      )}

      {/* Banner Section */}
      <section className="banner-spac">
        <div className="cust-container">
          <div className="banner-box">
            <img src={corpBanner} alt="Banner" />
            <div className="ban-con">
              <h1>Associated Corporates, TPAs & Insurance Companies</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Corporates & TPAs Section */}
      <section className="asso-cor-tps-sec mrgntop70 margnbot90">
        <div className="cust-container">
          <div className="row">
            {/* List of Corporates */}
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mb-4">
              <div className="asso-cor-tps-sec-item">
                <p>List of Corporates:</p>
                <ul className="level1">
                  {corporate
                    .slice(0, showAllCorporates ? corporate.length : 6)
                    .map((liItem, index) => (
                      <li
                        
                        key={index}
                        dangerouslySetInnerHTML={{ __html: liItem }}
                      />
                    ))}
                </ul>
                {/* {corporate
                    .slice(0, showAllCorporates ? corporate.length : 10)
                    .map((corporate, index) => (
                      <li
                        key={index}
                        dangerouslySetInnerHTML={{
                          __html: corporate.corporate_name,
                        }}
                      />
                    ))}
                </ul> */}
                <button
                  className="btnTpa"
                  onClick={() => setShowAllCorporates(!showAllCorporates)}
                >
                  {showAllCorporates ? "Show Less" : "Load More..."}
                </button>
              </div>
            </div>

            {/* List of TPAs & Insurance Companies */}
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mb-4">
              <div className="asso-cor-tps-sec-item">
                <p>List of TPAs & Insurance Companies:</p>
                <ul className="level1">
                  {tpainsurance
                    .slice(0, showAllTpas ? tpainsurance.length : 6)
                    .map((liItem, index) => (
                      <li
                        key={index}
                        dangerouslySetInnerHTML={{ __html: liItem }}
                      />
                    ))}
                </ul>
                {/* {tpainsurance
                    .slice(0, showAllTpas ? tpainsurance.length : 10)
                    .map((tpa, index) => (
                      <li
                        key={index}
                        dangerouslySetInnerHTML={{ __html: tpa.name }}
                      />
                    ))}
                </ul> */}
                <button
                  className="btnTpa"
                  onClick={() => setShowAllTpas(!showAllTpas)}
                >
                  {showAllTpas ? "Show Less" : "Load More..."}
                </button>
              </div>
            </div>
          </div>

          {/* Note Section */}
          <div className="asso-corpnote">
            <p>
              The empanelment list is for reference only. Please verify the
              current status with your Corporate/Insurance Company/TPA before
              admission. For assistance, call{" "}
              <span>022-66529612 (TPA Helpdesk)</span> or email{" "}
              <a
                href="mailto:tpacell@rahejahospital.com"
                style={{
                  color: "#000",
                  textDecoration: "underline !important",
                }}
              >
                tpacell@rahejahospital.com
              </a>
              .
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default AcTpas;
